/* eslint-disable */
import axios from 'axios';

const data = {
  qoute: {},
  renewalClient: {},
};
const getters = {
  fetchQoute: (state) => state.qoute,
  renewalClient: (state) => state.renewalClient,
};

const mutations = {
  updateQuotation(state, payload) {
    state.qoute = payload;
  },
  updateRenewalClient(state, payload) {
    state.renewalClient = payload;
  },
};
const actions = {
  fetchRenewalClient: async (context, id) => {
    await axios.get(`/customer/gis/clients/renewalClients?batchNo=${id}`).then(async (response) => {
      context.commit('updateRenewalClient', response.data.object);
    });
  },
  fetchQuotation: async (context, params) => {
    // eslint-disable-next-line radix
    await axios.post(`/motor/api/policy/vehicles`, {
      batchNo: params.batchNo
    }).then((response) => {
      if (response.data.code == 0) {
        context.commit('updateQuotation', response.data.data[0]);
      }
    });
  },
};

export default {
  namespaced: true,
  state: data,
  getters,
  actions,
  mutations,
};
